module.exports = __webpack_public_path__ + "static/media/JB-Bold.47b94e19.woff2";